import { useMemo } from 'react';

import { useAuth } from './AuthContext';
import { buildCan, type CanFn } from './permissions';

/** Returns `can(cap, ctx?)` for the current user. UX gating only. */
export function useCan(): CanFn {
  const { user } = useAuth();
  return useMemo(() => buildCan(user), [user]);
}
